window.app = {}

load()

function load() {
	setupAgentVariables()
}

function setupAgentVariables() {
	const agent = {}

	/**
	 *
	 * @type {string}
	 */
	const userAgent = navigator.userAgent

	// Electron
	const isElectron = agent.electron = (() => {
		return userAgent.includes('Electron/')
	})()

	// Browsers
	const isSafari = /Safari/i.test(userAgent)
		&& !isElectron // Safari 1.0 - 6.0
		&& !/Opera|OPR/i.test(userAgent) // Opera 8.0 - 15

	/**
	 *
	 * @type {number}
	 */
	agent.maxTouchPoints = navigator.maxTouchPoints || (
		/iPhone|iPad|iPod/i.test(userAgent)
			? 5 // iOS <= 12
			: 0
	)

	/**
	 *
	 * @type {boolean}
	 */
	agent.iOS = isSafari && agent.maxTouchPoints > 1

	/**
	 *
	 * @type {boolean}
	 */
	agent.mac = navigator.platform.startsWith('Mac')

	/**
	 *
	 * @type {boolean}
	 */
	agent.firefox = userAgent.includes('Firefox')

	/**
	 *
	 * @type {boolean}
	 */
	agent.safari = isSafari

	/**
	 * TRUE if the user is probably using Chrome OS
	 * @type {boolean}
	 */
	agent.chromeOS = userAgent.includes('CrOS')

	/**
	 *
	 * @type {boolean}
	 */
	agent.windows = navigator.platform.startsWith('Win32')

	/**
	 *
	 * @type {boolean}
	 */
	agent.windows10 = userAgent.includes('Windows NT 10')

	app.agent = agent
}